export const locales = [
  {
    language: 'en',
    langIso: 'en',
    title: 'English',
    messages: require('./locales/en.json'),
  },
  {
    language: 'ru',
    langIso: 'ru',
    title: 'Русский',
    messages: require('./locales/ru.json'),
  },
  {
    language: 'ar',
    langIso: 'ar',
    title: 'العربية',
    messages: require('./locales/ar.json'),
  },
  {
    language: 'es',
    langIso: 'es',
    title: 'Español',
    messages: require('./locales/es.json'),
  },
  {
    language: 'pt',
    langIso: 'pt',
    title: 'Português',
    messages: require('./locales/pt.json'),
  },
  {
    language: 'th',
    langIso: 'th',
    title: 'ภาษาไทย',
    messages: require('./locales/th.json'),
  },
  {
    language: 'vi',
    langIso: 'vi',
    title: 'Tiếng Việt',
    messages: require('./locales/vi.json'),
  },
];

export const CONFIG = {
  API_URL: API_URL || `/api`,
  PHONE_API_URL: `https://api.${BASE_DOMAIN}/format/phone/countries`,
  COOKIE_CONFIG: {
    path: '/',
    secure: true,
    expires: new Date(new Date().setFullYear(new Date().getFullYear() + 10)),
  },
};
